import { FC, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

export type TPgField = [label: string, value: ReactNode];

type TPgFieldsProps = {
	items: TPgField[];
	/** Minimal width of one column. */
	minWidth?: number;
};

/** Label / value pairs in a responsive grid. */
export const PgFields: FC<TPgFieldsProps> = ({ items, minWidth = 220 }) => (
	<Box
		sx={{
			display: 'grid',
			gridTemplateColumns: `repeat(auto-fill, minmax(${minWidth}px, 1fr))`,
			gap: '8px 16px',
		}}
	>
		{items.map(([label, value]) => (
			<Box key={label} sx={{ minWidth: 0 }}>
				<Typography variant="caption" color="text.secondary" component="div">
					{label}
				</Typography>
				<Typography variant="body2" component="div" sx={{ wordBreak: 'break-word' }}>
					{value === null || value === undefined || value === '' ? '—' : value}
				</Typography>
			</Box>
		))}
	</Box>
);

type TPgJsonViewProps = { value: unknown; maxHeight?: number };

/** Pretty-printed JSON in a scrollable block. */
export const PgJsonView: FC<TPgJsonViewProps> = ({ value, maxHeight = 320 }) => {
	let text: string;
	try {
		text = JSON.stringify(value ?? null, null, 2);
	} catch {
		text = String(value);
	}
	return (
		<Box
			component="pre"
			sx={{
				m: 0,
				p: 1,
				maxHeight,
				overflow: 'auto',
				fontSize: '0.75rem',
				backgroundColor: 'action.hover',
				borderRadius: 1,
				whiteSpace: 'pre-wrap',
				wordBreak: 'break-all',
			}}
		>
			{text}
		</Box>
	);
};
